import { HostContainer } from "../../../../features/product-search-shared/components/products-subcategory-search/product-subcategory-search.styles";
import { Box, FormLabel } from "@material-ui/core";
import { SearchField } from "../../search-field/search-field.component";
import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { Nullable } from "../../../../types/common";
import { SearchSuggestProps } from "./search-suggest.props";

export const SearchSuggest = (props: SearchSuggestProps) => {
  const ref: MutableRefObject<Nullable<HTMLDivElement>> = useRef(null);
  const [shouldReset, setShouldReset] = useState(false);

  useEffect(
    () => {
      document.addEventListener("click", handlePageClick);
      return () => document.removeEventListener("click", handlePageClick);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setShouldReset(props.reset || false);
  }, [props]);

  const handlePageClick = (e: any) => {
    if (ref.current && !ref.current?.contains(e.target)) {
      setShouldReset(true);
      props.onReset();
    }
  };

  return (
    <HostContainer ref={ref}>
      <label>
        <Box display="flex" justifyContent="space-between">
          <FormLabel component="h3">{props.label}</FormLabel>
        </Box>
        <SearchField
          id={props.id || ""}
          label={props.label}
          placeholder={props.placeholder || "Search"}
          size="small"
          isDisabled={props.disabled || false}
          resetSearch={shouldReset || props.reset}
          onSearch={props.onSearch}
          onCancel={props.onReset}
        />
      </label>
      {props.children}
    </HostContainer>
  );
};
